import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export default function useSiteSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const snap = await getDoc(doc(db, 'config', 'global'));
        if (snap.exists()) {
          const data = snap.data();
          setSettings({
            ...data,
            siteName: data.siteName?.replace(/\bLabs\b/g, 'Lab'),
            contactEmail: 'astemsoftwarelab@gmail.com',
          });
        }
      } catch (err) {
        console.error('❌ Error fetching site settings:', err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
}
